import React, { Dispatch, FC, ReactNode, SetStateAction } from 'react';
import { Box, Drawer, IconButton, Typography } from '@mui/material';
import { COLORS_CONST } from '../../helpers/styles';
import {
  ArrowBack,
  ArrowForwardIosRounded,
  KeyboardDoubleArrowRightRounded,
} from '@mui/icons-material';
import { BoxTab } from './BoxTab';
import { PatchesName, StepsEnum } from '../../helpers/types';
import { useNavigate } from 'react-router-dom';
import { useGetNameProjectQuery } from '../../graphql/casheQuery/__generated__/getNameProject';

interface Props {
  isOpen: boolean;
  closeDrawer(): void;
  // handleDrawerOpen: Dispatch<SetStateAction<boolean>>;
  children?: ReactNode | undefined;
  handlerSelectStep(step: StepsEnum): void;
  selectedStep: StepsEnum;
}

const steps = Object.values(StepsEnum)
  .filter(item => typeof item === 'number')
  .map(item => {
    if (+item === 4) {
      return `Настройки`;
    }
    return `Шаг-${+item + 1}`;
  });
export const DrawerCustom: FC<Props> = ({
  isOpen,
  closeDrawer,
  selectedStep,
  handlerSelectStep,
  // handleDrawerOpen,
  children,
}) => {
  const navigate = useNavigate();
  const { data: projectName } = useGetNameProjectQuery();

  const handlerGoToProfile = () => {
    navigate(`/${PatchesName.Profile}`);
  };

  const getTabs = () => {
    const startTop = 80;
    const offset = 110;
    return steps.map((item, index) => {
      return (
        <BoxTab
          handlerClick={() => handlerSelectStep(index)}
          key={index.toString()}
          top={startTop + offset * index}
          title={item}
          isSelected={selectedStep === index}
        />
      );
    });
  };

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={closeDrawer}
      hideBackdrop
      disableEnforceFocus
      sx={{
        '&': {
          width: 0,
          height: 0,
        },
        '& .MuiDrawer-paper': {
          overflowY: 'visible',
        },
      }}
    >
      <Box
        width="300px"
        height="100%"
        bgcolor={COLORS_CONST.basic}
        p="30px 28px"
        boxSizing="border-box"
      >
        <Typography fontSize="1.3em" color="#fff" textTransform="none" noWrap>
          {`Проект: ${projectName?.nameProject}`}
        </Typography>
        <Box display="flex" alignItems="center" width="100%" flexDirection="row">
          <IconButton onClick={handlerGoToProfile} edge="start">
            <ArrowBack style={{ fontSize: '30px', color: '#ffffff' }} />
          </IconButton>
          <Typography fontStyle="italic" fontSize="1em" color="#fff" textTransform="none">
            Выйти в профиль
          </Typography>
        </Box>
        {children}
      </Box>
      {getTabs()}
      <Box
        width="40px"
        left="-15px"
        height="40px"
        display="flex"
        bgcolor="#18318E"
        position="absolute"
        borderRadius="20px"
        alignItems="center"
        justifyContent="center"
        top={`calc(50% + 200px)`}
      >
        <IconButton
          onClick={() => closeDrawer()}
          color="inherit"
          sx={{
            '&': {
              border: '1px solid #fff',
            },
          }}
        >
          <ArrowForwardIosRounded sx={{ color: '#fff', fontSize: '14px' }} />
        </IconButton>
      </Box>
    </Drawer>
  );
};
